import React, { useState, useEffect, useContext } from "react";
// Components
import DisputesHeaderDark from "../Components/DisputesHeaderDark";
import DisputePageTitle from "../Components/DisputePageTitle";
import { Col, Row } from "react-bootstrap";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import { AuthContext } from "../AuthProvider";

import TextEditor from "../Components/TextEditor";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "align",
];

const getHelps = async (setHelps, setError) => {
  try {
    const accessToken = localStorage.getItem("accessToken")
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}helps/`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    );
    setHelps(response.data);
  } catch (error) {
    setError("Error fetching help contents!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

const handleHelpSubmit = async (
  value,

  selectedHelp,
  setError,
  setSuccess
) => {
  const accessToken = localStorage.getItem("accessToken");
  const data = {
    content: value,

  };
  try {
    const response = await axios.patch(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}help/${selectedHelp.id}/update/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.data?.error) {
      setError("Error while updating help content!");
    } else {
      setSuccess("Help Content Updated!");
      setTimeout(() => {
        setSuccess(null);
      }, "2000");
    }
  } catch (error) {
    if (error.response) {
      setError("Error while updating help content!");
      setTimeout(() => {
        setError(null);
      }, "2000");
    } else if (error.request) {
      console.error("Network Error: No response received");
      setError("Error while updating help content!");
      setTimeout(() => {
        setError(null);
      }, "2000");
    } else {
      console.error("Unexpected Error:", error.message);
      setError("Error while updating help content!");
      setTimeout(() => {
        setError(null);
      }, "2000");
    }
  }
};

const getFiles = async (setFiles, setError) => {
  try {
    const response = await axios.get(
      "https://www.googleapis.com/drive/v3/files",
      {
        params: {
          q: "'15JSF0F4hEfYoHJmKfXv5Cy_M0ti_-HMH' in parents",
          key: window.__RUNTIME_CONFIG__.REACT_APP_GOOGLE_DRIVE_API,
          fields: "files(id, name, webViewLink, mimeType)",
          supportsAllDrives: true,
          includeItemsFromAllDrives: true,
        },
      }
    );

    setFiles(response.data.files);
  } catch (error) {
    console.error(
      "Error fetching files:",
      error.response?.data || error.message
    );
    setError("Error fetching files from Google Drive!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

export default function ManageHelp() {
  const [files, setFiles] = useState([]);
  const [selectedHelp, setSelectedHelp] = useState();

  const [value, setValue] = useState();

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [helps, setHelps] = useState(null);

  const { isLoggedIn, isAdmin, loading } = useContext(AuthContext);

  useEffect(() => {
    getHelps(setHelps, setError);

    getFiles(setFiles, setError);
  }, [success]);

  return (
    <>
      <DisputesHeaderDark />
      {isAdmin && (
        <>
          <div className="relative">
            <DisputePageTitle title="Manage Help" />
          </div>

          <section className="pb-[160px] overflow-hidden cover-background ">
            <Row>
              <Col
                lg={3}
                className=" p-5 pt-4"
                data-test="notices-manage-navbar"
              >


                <div className="bg-lightgray p-4 text-dark max-h-screen overflow-y-scroll">

                  {helps &&
                    helps.map((help) => {
                      return (
                        <p
                          className={`${
                            help.id === selectedHelp?.id
                              ? "bg-[#ef8d23] text-white"
                              : ""
                          } p-1 hover:text-[#ef8d23]`}
                          key={help.id}
                        >
                          <Link
                            onClick={() => {
                              setSelectedHelp(help);
                              setValue(help.content);


                              setSuccess(null);
                            }}
                            data-test="notices-manage-link"
                          >
                            {help.model}
                          </Link>
                        </p>
                      );
                    })}
                </div>
              </Col>
              <Col lg={8} className="p-5">
                {success && (
                  <motion.div
                    initial={{
                      scale: 0.8,
                      opacity: 0,
                    }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                    }}
                  >
                    {success && (
                      <div
                        className="my-3 p-3 rounded text-[#ef8d23]"
                        style={{ border: "2px solid #ef8d23" }}
                      >
                        {success}
                      </div>
                    )}
                  </motion.div>
                )}
                {error && (
                  <motion.div
                    initial={{
                      scale: 0.8,
                      opacity: 0,
                    }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                    }}
                  >
                    {error && (
                      <div
                        className="my-3 p-3 rounded text-danger"
                        style={{ border: "2px solid red" }}
                      >
                        {error}
                      </div>
                    )}
                  </motion.div>
                )}

                {selectedHelp && (
                  <>



                    <div
                      style={{ maxHeight: "600px", overflow: "auto" }}
                      className="border-bottom"
                    >
                      <TextEditor
                        value={value}
                        setValue={setValue}
                        formats={formats}
                        urlOptions={files}
                      />
                    </div>
                    <div className="flex justify-content-between">
                      <div>
                        <button
                          className={
                            "mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                          }
                          onClick={() =>
                            handleHelpSubmit(
                              value,

                              selectedHelp,
                              setError,
                              setSuccess
                            )
                          }
                          data-test="notices-manage-update"
                        >
                          Update
                        </button>
                      </div>

                    </div>
                    <div className="mt-5">
                      <h5 className="uppercase text-center text-[#ef8d23] font-bold">
                        Preview of Current Changes
                      </h5>

                      <p
                        className="text-black ql-editor"
                        style={{ lineHeight: "2" }}
                        dangerouslySetInnerHTML={{ __html: value }}
                        data-test="notices-manage-preview"
                      ></p>
                    </div>
                  </>
                )}
              </Col>
            </Row>
          </section>
        </>
      )}
      {!isLoggedIn && <DisputePageTitle title="Unauthorized" />}
      {isLoggedIn && !isAdmin && <DisputePageTitle title="Unauthorized" />}
    </>
  );
}
